module.exports = __webpack_public_path__ + "img/circle-question-sharp-light.0d334f85.svg";